import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
  import Modal from "@/components/ui/Modal.vue";
  import router from "@/router";
  import store from "@/store";
  import { useToast } from "vue-toastification";
  import getUserData from "@/helpers/listing/getUserData";
  import { useRequest } from "@/features/useRequest";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'CompletedResForm',
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    eoiId: {
      type: Object,
      required: true,
    },
    isDocusignEnabled: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["close", "share", "generate"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const isRequestAccessEmailSent = ref(false);

  const emits = __emit;
  const loading = ref(false);

  const { error, handleRequestWithLoading } = useRequest();

  const toast = useToast();
  const props = __props;

  const close = () => {
    emits("close");
  };

  const share = () => {
    emits("close");
    emits("share");
  };

  const generate = () => {
    emits("close");
    emits("generate");
  };

  const getSalesAdviceDocument = async () => {
    await handleRequestWithLoading<string, Record<string, any>>(
      "eoi/downloadPdf",
      props.eoiId,
      loading
    ).then((res) => {
      emits("close");

      if (res?.data) {
        window.open(res.data, "_blank");
      }
    });
  };

  const requestDocusignAccess = async () => {
    const { estateId } = getUserData();
    const res = await handleRequestWithLoading<void, string>(
      "docusign/sendRequestAccessNotification",
      estateId,
      loading
    );

    if (!error.value && !loading.value && res.success)
      isRequestAccessEmailSent.value = true;
  };

const __returned__ = { isRequestAccessEmailSent, emits, loading, error, handleRequestWithLoading, toast, props, close, share, generate, getSalesAdviceDocument, requestDocusignAccess, ref, Modal, get router() { return router }, get store() { return store }, get useToast() { return useToast }, get getUserData() { return getUserData }, get useRequest() { return useRequest } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})